import * as React from 'react';

interface State {
  hasError: boolean;
}

interface Props {
  children: React.ReactNode;
  /** Optional fallback rendered when an error is caught. Defaults to null (silent). */
  fallback?: React.ReactNode;
}

/**
 * Tiny error boundary for the PeaceFlame component tree. Any crash during
 * canvas/audio initialization is contained so the host page keeps rendering.
 *
 * Silent by default (renders nothing on error) — the surrounding page UI
 * remains responsive even if the torch fails to start.
 */
export default class PeaceFlameErrorBoundary extends React.Component<
  Props,
  State
> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: unknown, info: React.ErrorInfo) {
    // Console-only — there's no app-wide error reporter wired here yet.
    console.error('PeaceFlame crashed:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback ?? null;
    }
    return this.props.children;
  }
}
